export default __webpack_public_path__ + "static/media/36I-117132_-37265_0.294649a8.jpg";